// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.chain",
    name: "Chain",
    homepage: "https://chain.com",
    image_id: "f9f3d8da-e791-47d2-98c2-031712617e00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/id6444779277",
        android: null,
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "chainapp://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map